import styled from 'styled-components';

export const BasicFilter = styled.p`
  margin: 0;
  padding: 0;
`;

// The Status column is excluded from the class so the Inactive chip stays legible.
export const DimInactiveRows = styled.div`
  & .MuiDataGrid-cell.cell--inactive {
    opacity: 0.5;
  }
`;
